import type { ReactNode } from "react";

import { mergePt } from "../../utils/merge-pt";
import { SELECT_PANEL_ITEMS_CLASS } from "./select-panel-classes";
import { SelectPanelScrollBar } from "./select-panel-scroll-bar";
import styles from "./select-panel.module.scss";

const WRAPPER_SELECTOR = {
  dropdown: ".p-dropdown-items-wrapper",
  multiselect: ".p-multiselect-items-wrapper",
} as const;

type SelectKind = keyof typeof WRAPPER_SELECTOR;

type FooterTemplate = ReactNode | ((props: never, onHide: () => void) => ReactNode);

interface PanelProps {
  pt?: object;
  panelFooterTemplate?: FooterTemplate;
}

/**
 * Lista do painel com a barra nativa oculta e a `ScrollBar` do DS sobreposta à borda direita (Figma 10489:113704).
 * O `pt` e o `panelFooterTemplate` da tela são mantidos; os do DS se somam a eles.
 */
export function withSelectPanelScrollBar<P extends PanelProps>(kind: SelectKind, props: P) {
  const { panelFooterTemplate: own } = props;
  return {
    pt: mergePt(
      { wrapper: { className: SELECT_PANEL_ITEMS_CLASS }, footer: { className: styles.footer } },
      props.pt,
    ),
    panelFooterTemplate: ((templateProps: never, onHide: () => void): ReactNode => (
      <>
        {typeof own === "function" ? own(templateProps, onHide) : own}
        <SelectPanelScrollBar wrapperSelector={WRAPPER_SELECTOR[kind]} />
      </>
    )) as P["panelFooterTemplate"],
  };
}
